import instance from "./instance";

const SmtownAPI = () => {
  return instance.get(`/smtown`);
};

export default SmtownAPI;
